import '../App.css';

const PaginaNaoEncontrada = () => {

  return (
    <div className="container-not-found">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Ops! Página não encontrada</h2>
        <p>Esta página não existe ou pode ter sido movida.</p>
      </div>
    </div>
  );
};

export default PaginaNaoEncontrada;